import { Component } from '@angular/core';
import { environmentCommon } from 'src/environments/environment-common';
import { URLS } from '../../../../data/navigation/navigation.data';

/**
 * The privacy policy of Tidy Desktop: AI Organizer, the macOS desktop organizer, at
 * /plugins/macos/tidy-desktop/privacy (linked from the foot of the app's page, as Dock Town's;
 * owner 2026-10-10). It says what the app does with data and nothing beyond it, checked against
 * the app's sources (macos-tidy-desktop): when the app changes how it handles data, change the
 * text and the effective date together.
 */
@Component( {
  selector: 'app-tidy-desktop-privacy-page',
  templateUrl: './tidy-desktop-privacy-page.component.html',
  styleUrls: [ './tidy-desktop-privacy-page.component.scss' ]
} )
export class TidyDesktopPrivacyPageComponent {

  URLS = URLS;

  environmentCommon = environmentCommon;

  // Apple's standard licence for App Store apps: Tidy Desktop's Terms of Use.
  readonly eulaUrl = 'https://www.apple.com/legal/internet-services/itunes/dev/stdeula/';

  constructor() {
    // Intentionally Blank
  }
}
